(function () {
  function initCarousel(section) {
    var track = section.querySelector('[data-apx-track]');
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-apx-card]'));
    var dots = Array.prototype.slice.call(section.querySelectorAll('[data-apx-dot]'));
    if (!track || !cards.length) return;
 
    function videoOf(card) {
      return card.querySelector('video');
    }
 
    function setActive(index) {
      cards.forEach(function (card, i) {
        var isActive = i === index;
        card.toggleAttribute('data-apx-active', isActive);
        if (!isActive) {
          var v = videoOf(card);
          if (v) {
            v.pause();
            card.removeAttribute('data-apx-playing');
          }
        }
      });
      dots.forEach(function (dot, i) {
        dot.toggleAttribute('data-apx-dot-active', i === index);
      });
    }
 
    // Track which card is most centered while scrolling
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
            var index = cards.indexOf(entry.target);
            if (index !== -1) setActive(index);
          }
        });
      },
      { root: track, threshold: [0.6] }
    );
    cards.forEach(function (card) { observer.observe(card); });
 
    cards.forEach(function (card) {
      var video = videoOf(card);
      var playBtn = card.querySelector('[data-apx-play-toggle]');
      var soundBtn = card.querySelector('[data-apx-sound-toggle]');
 
      if (playBtn) {
        playBtn.addEventListener('click', function () {
          if (!video) return;
          if (video.paused) {
            video.play();
            card.setAttribute('data-apx-playing', '');
          } else {
            video.pause();
            card.removeAttribute('data-apx-playing');
          }
        });
      }
 
      if (video) {
        video.addEventListener('click', function () {
          if (video.paused) {
            video.play();
            card.setAttribute('data-apx-playing', '');
          } else {
            video.pause();
            card.removeAttribute('data-apx-playing');
          }
        });
        video.addEventListener('play', function () {
          card.setAttribute('data-apx-playing', '');
        });
        video.addEventListener('pause', function () {
          card.removeAttribute('data-apx-playing');
        });
      }
 
      if (soundBtn) {
        soundBtn.addEventListener('click', function () {
          if (!video) return;
          video.muted = !video.muted;
          soundBtn.setAttribute('aria-pressed', String(!video.muted));
        });
      }
    });
 
    setActive(0);
  }
 
  function init() {
    document.querySelectorAll('.apx-vc').forEach(initCarousel);
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
 
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.apx-vc');
    if (section) initCarousel(section);
  });
})();